import type { AppDefinition, AppIcon } from '../../types/apps';

export const DOCS_EVENTS = {
  CREATE_DOC: 'DOCS_CREATE',
  DELETE_DOC: 'DOCS_DELETE',
  UPDATE_DOC: 'DOCS_UPDATE',
  OPEN_DOC: 'DOCS_OPEN',
  TOGGLE_DARK_MODE: 'DOCS_TOGGLE_DARK_MODE',
} as const;

/**
 * Docs app chiplet — dark rounded container + glyph.
 * Use ONLY for the Docs app itself (Dock, AppSquircle, Docs overview).
 * Never use this for individual Doc entities in the sidebar/lists.
 */
export const DOCS_APP_ICON_PATH = '/icons/docsApp.svg';

/**
 * Bare Doc glyph — no background container.
 * Use for every Doc / Document entity (sidebar, lists, tool cards, create menus).
 */
export const DOCS_ENTITY_ICON_PATH = '/icons/riverAppDocSmall.svg';

export const DOCS_ENTITY_ICON: AppIcon = {
  type: 'svg',
  svgPath: DOCS_ENTITY_ICON_PATH,
  metadata: {
    source: 'app',
    appId: 'docs',
    entityType: 'Doc',
    isAppIcon: false,
  },
};

export const DOCS_APP_ICON: AppIcon = {
  type: 'image',
  imagePath: DOCS_APP_ICON_PATH,
  metadata: {
    source: 'app',
    appId: 'docs',
    isAppIcon: true,
  },
};

export const DocsAppDefinition: AppDefinition = {
  appId: 'docs',
  name: 'Docs',
  version: '1.0.0',
  description: 'Create and manage documents',
  icon: DOCS_APP_ICON,
  events: {},
  // 'Doc' is the real entityType used by every doc-creation path (docsAppStore,
  // docs_create, word/Google Docs import); 'Document' is kept for legacy data.
  // Both must be listed so iconService.getAppForEntityType() resolves Docs to
  // this app's own entityIcons below, instead of falling through to another
  // app that happens to declare 'Doc' in its own entityTypes.
  entityTypes: ['Doc', 'Document'],
  searchableSkeletonFields: {
    Document: [], // name-only — body content too large for sync extraction
    Doc:      [], // name-only — body content too large for sync extraction
  },
  component: 'DocsApp',
  requiresProps: false,
  requiresEntity: true,
  isCore: true,
  // Individual Doc entities use the bare glyph — never the app chiplet.
  entityIcons: {
    Doc: {
      ...DOCS_ENTITY_ICON,
      metadata: {
        ...DOCS_ENTITY_ICON.metadata,
        entityType: 'Doc',
      },
    },
    Document: {
      ...DOCS_ENTITY_ICON,
      metadata: {
        ...DOCS_ENTITY_ICON.metadata,
        entityType: 'Document',
      },
    },
  },
};
